<template>
  <div class="pa-2">
    <div class="section-bg pa-2 rounded-lg">
      <v-layout
        class="caption ma-0 cursor-pointer"
        @click="openGoods"
      >
        <div class="mr-2">
          <KImg
            :src="goods.itemPic"
            replaceTbOrigin
            width="70"
            style="border-radius: 10px;"
          />
        </div>
        <v-flex>
          <div class="line-clamp-2">
            <TraPlatformIcon :tpttPlatform="goods.isTmall ? 'tmall' : 'taobao'" />
            {{ goods.itemName }}
          </div>

          <v-layout
            align-center
            class="mt-2"
          >
            <div class=" red--text">
              ￥<b class="text-large-2 mr-1">{{ goods.itemFinalPrice }}</b>
            </div>
            <v-spacer />

            <GoodsCoin
              v-if="goods.itemTbk && goods.itemTbk.can_mail_click_url"
              :item="goods"
              :itemid="goods.itemid"
              view="num"
            >
              <span>
                返金巧幣
                <img
                  src="https://m.kkren.com.tw/h5-static/coin/金巧币.png"
                  height="12"
                  style="vertical-align: text-bottom;margin-bottom: 2px;"
                  class="mx-0"
                > {{ goods.rebateCoin }}
              </span>
            </GoodsCoin>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import TraPlatformIcon from '@g/components/TraPlatformIcon'
import { coverItemUrl, getRebateCoinAmount } from '@g/utils/tbkUtils'
import {
  actOpenSysBrowser,
} from '@g/utils/appSDK'
import GoodsCoin from './GoodsCoin.vue'

export default {
  components: {
    TraPlatformIcon,
    GoodsCoin,
  },
  props: {
    goods: Object,
  },
  methods: {
    openGoods () {
      if (this.goods.itemTbk) {
        const url = coverItemUrl(this.goods.itemTbk.can_mail_click_url)
        window.open(this.goods.itemTbk.can_mail_click_url, '_blank')
      }
    },
  },
}
</script>
